class NavigationItem {
  /**
   * Create new main navigation item
   * @param {HTMLElement} trigger The clicky button
   */
  constructor(trigger) {
    this.trigger = trigger
    this.container = trigger.parentElement
    this.target = document.querySelector(trigger.dataset.target)
    this.isOpen = trigger.classList.contains('is-active')
  }

  /**
   * Attach event listeners
   */
  init() {
    this.trigger.addEventListener('click', () => this.toggle())
  }

  /**
   * Open navigation item
   */
  open() {
    this.container.classList.add('is-open')
    this.trigger.setAttribute('aria-expanded', 'true')

    this.isOpen = true
  }

  /**
   * Close navigation item
   */
  close() {
    this.container.classList.remove('is-open')
    this.trigger.setAttribute('aria-expanded', 'false')

    this.isOpen = false
  }

  /**
   * Toggle between open and close state
   */
  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }
}

const triggers = document.querySelectorAll('.js-navigation-main-trigger')

for (const trigger of triggers) {
  new NavigationItem(trigger).init()
}
